import React from "react";
import { BrainIcon, GraduationCapIcon, RadioIcon, UsersIcon, WrenchIcon } from "lucide-react";
import { includes } from "../../data/program";
const icons = {
  platform: GraduationCapIcon,
  live: RadioIcon,
  community: UsersIcon,
  mindset: BrainIcon,
  resources: WrenchIcon
};
export function Includes() {
  return <section className="mx-auto max-w-7xl px-5 py-16 sm:px-6 md:py-28" data-id="element-90" data-mp="125sqsj7ynstq">
      <div className="grid gap-12 md:grid-cols-[1fr_1.6fr] md:gap-20" data-id="element-91" data-mp="1zsrjkivj8gmc">
        <h2 className="font-display text-4xl font-black uppercase leading-none md:text-6xl" data-id="element-92" data-mp="1ut6gpxd8ro4c">¿Qué recibes?</h2>
        <ul className="divide-y divide-line border-y border-line" data-id="element-93" data-mp="1q26kyvfuzc3f">
          {includes.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-5 py-6" data-id="element-94" data-mp="1l193ym6l4o3i">
                <Icon className="mt-1 h-6 w-6 shrink-0 text-accent" aria-hidden data-id="element-95" data-mp="2ijiz62645396" />
                <div data-id="element-96" data-mp="2drr3jd83o7c6">
                  <p className="font-display text-xl font-extrabold uppercase" data-id="element-97" data-mp="2dr9304een6yg">{item.title}</p>
                  <p className="mt-1 text-lg text-paper/70" data-id="element-98" data-mp="wu1yus1k4v7k">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}